export const Archive = 'archive'
export const Analysis = 'analysis'
export const Missing = 'missing'
